(() => {
  'use strict';
  function initializeProduct(root) {
    const select = root.querySelector('[data-variant-select]');
    if (!select || select.dataset.initialized) return;
    select.dataset.initialized = 'true';
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const price = root.querySelector('[data-variant-price]');
      const compare = root.querySelector('[data-compare-price]');
      const button = root.querySelector('[data-add-button]');
      const label = root.querySelector('[data-add-label]');
      price.textContent = option.dataset.price;
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      button.disabled = option.dataset.available !== 'true';
      label.textContent = button.disabled ? 'Sold out' : 'Add to bag';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  }
  function initialize(scope) { scope.querySelectorAll('[data-product-section]').forEach(initializeProduct); }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(menu => menu.removeAttribute('open'));
  });
})();
